/* eslint-disable max-len */
import { FunctionComponent } from 'react';
import { useGlobalState } from '../../contexts';
// import AppBarDropDown from '../../svgs/AppBarDropDown';
import AppBarNotificationIcon from '../../svgs/AppBarNotificationIcon';
import MobileMenuIcon from '../../svgs/MobileMenuIcon';

import { getItemsToLocalStorage, getNameInitials } from '../../utils/helpers';
import AvatarImage from '../AvaterImage';

import './AdminTopBar.scss';

export interface ITopNav {
  label?: string;
  dropdownObj?: any;
}

const AdminTopNav: FunctionComponent<ITopNav> = ({ dropdownObj }) => {
  const { profile } = useGlobalState();
  const { email, firstName, lastName } = profile;
  const initials = getNameInitials(email);
  const mobileTitleBar = getItemsToLocalStorage('nav-title');

  const handleToggleMenu = () => {
    dropdownObj?.setShowSideBar(true);
  };

  const avatar = profile?.imageUrl || '';
  return (
    <div className="admin-navbar-cover d-flex">
      <div className="admin-navbar-cover-menu">
        <span onClick={handleToggleMenu}>
          <MobileMenuIcon />
        </span>

      </div>
      <div className="admin-navbar-cover-mobile-title">{mobileTitleBar}</div>
      <div className="admin-navbar-cover-details d-flex">
        <div className="admin-navbar-cover-details-avatar">
          <div className="admin-navbar-cover-details-icon">
            <AppBarNotificationIcon />
          </div>
          <span>
            { avatar
              ? <AvatarImage alt={initials} image={avatar} />
              : (
                <div className="avatar-initials">
                  {getNameInitials(profile?.firstName)}
                </div>
              )}
          </span>

          <div className="admin-navbar-cover-details-avatar-names">
            {/* <div className="admin-navbar-cover-details-avatar-names-title">{profile?.role?.name}</div> */}
            <div className="admin-navbar-cover-details-avatar-names-subtitle">
              {`${firstName} ${lastName}`}
              {/* <span><AppBarDropDown /></span> */}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
export default AdminTopNav;
